import { Box, IconButton } from "@mui/material"
import { NewAddRoundIcon } from "../../../../../core/global/Icons"

export const Top = (props) => {
    const { loc, cid, categoryForm, setCategoryForm } = props

    const addRowHandler = () => {
        setCategoryForm([ 
            {
                id:cid + categoryForm.length + 1,
                series_num:`CTGRY-000000000${cid + categoryForm.length + 1}`,
                category_name:'', 
                error:{stat:true, name:false, msg:'Fields Required!'},
                active:1,
                sub:[
                    { id:0, sub_name:'', sub_error:{stat:true, name:false, msg:'Fields Required!'} }
                ]
            }, ...categoryForm
        ])
    }

    return (
        <Box minHeight="80px" bgcolor="#ECECEC" borderRadius="10px" display="flex" alignItems="center" justifyContent="space-between" px={3}>
            <Box component="strong" fontSize={16}>{loc === 'create' ? 'Add' : 'Update' } Category</Box>
            {loc === 'create' && (
                (categoryForm.length < 5 ?
                    <IconButton id="walkthrough-category-step-4" onClick={addRowHandler} variant="contained" sx={{bgcolor:'primary.main', ':hover':{bgcolor:'#1B984F'} }} >
                        <NewAddRoundIcon/>
                    </IconButton>
                :
                    <Box component="strong" fontSize={12} color="red">Add Up to 5 Rows Only!</Box>
                )
            )}
        </Box>
    )
}